import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ExportsProvider } from './components/ExportBar';
import './styles.css';

/* `ExportsProvider` wraps the app rather than living inside it. The mode's
   primary export is pinned in the side panel's footer while the rest of the
   export bar stays at the bottom of the window — two different corners of the
   layout grid, sharing one "the worker encodes one file at a time" flag. Hoisted
   to here so `<App />` is a stable element: the provider's own state changes (an
   export's progress count ticking) then re-render the two button rows and
   nothing else. */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ExportsProvider>
      <App />
    </ExportsProvider>
  </StrictMode>,
);
